var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.567 12.5C7.567 12.5 6.57666 12.5 6.57666 11.5C6.57666 10.5 7.567 7.5 11.5284 7.5C15.4898 7.5 16.4801 10.5 16.4801 11.5C16.4801 12.5 15.4898 12.5 15.4898 12.5H7.567ZM11.5284 6.5C12.3163 6.5 13.072 6.18393 13.6292 5.62132C14.1864 5.05871 14.4994 4.29565 14.4994 3.5C14.4994 2.70435 14.1864 1.94129 13.6292 1.37868C13.072 0.816071 12.3163 0.5 11.5284 0.5C10.7404 0.5 9.98472 0.816071 9.42754 1.37868C8.87037 1.94129 8.55735 2.70435 8.55735 3.5C8.55735 4.29565 8.87037 5.05871 9.42754 5.62132C9.98472 6.18393 10.7404 6.5 11.5284 6.5Z",
    fill: "#6AA287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80027 12.5C5.65346 12.1878 5.58024 11.8455 5.58636 11.5C5.58636 10.145 6.25979 8.75 7.50366 7.78C6.88281 7.58684 6.23597 7.49237 5.58636 7.5C1.62499 7.5 0.634644 10.5 0.634644 11.5C0.634644 12.5 1.62499 12.5 1.62499 12.5H5.80027Z",
    fill: "#6AA287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09119 6.5C5.74782 6.5 6.37755 6.23661 6.84186 5.76777C7.30617 5.29893 7.56702 4.66304 7.56702 4C7.56702 3.33696 7.30617 2.70107 6.84186 2.23223C6.37755 1.76339 5.74782 1.5 5.09119 1.5C4.43456 1.5 3.80482 1.76339 3.34051 2.23223C2.8762 2.70107 2.61536 3.33696 2.61536 4C2.61536 4.66304 2.8762 5.29893 3.34051 5.76777C3.80482 6.23661 4.43456 6.5 5.09119 6.5Z",
    fill: "#6AA287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.5f415cc8fa0ea9122586f79699167446.svg";
export { ForwardRef as ReactComponent };